/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';
import { setCloseMsg } from '../../store/user.slice';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store/hooks';

export default function Message() {
  const dispatch = useDispatch();
  const { openMsg, messageData } = useAppSelector((state) => state.user);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setCloseMsg(false));
  };

  const vertical = 'top';
  const horizontal = 'horizontal';

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      key={vertical + horizontal}
      open={openMsg}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={messageData?.severity} sx={{ width: '100%' }}>
        {messageData?.text}
      </Alert>
    </Snackbar>
  );
}
